import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DateFormatPipe } from '@iot-platform/pipes';

@Component({
  selector: 'iot-platform-ui-chatbot-source-comment',
  imports: [FlexLayoutModule, DateFormatPipe, MatIconModule, MatButtonModule],
  templateUrl: './chatbot-source-comment.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './chatbot-source-comment.component.scss'
})
export class ChatbotSourceCommentComponent {
  source = input<any>();
  customStyle = input<string>();
}
